import { useMemo } from 'react';
export const useTextColor = ({ disabled, variant, fetching, loading, }) => {
    const color = useMemo(() => {
        if (loading)
            return 'neutral-200';
        if (variant === 'outlined') {
            if (disabled)
                return 'neutral-400';
            if (fetching)
                return 'white';
            return 'neutral-900';
        }
        if (variant === 'primary') {
            if (disabled)
                return 'neutral-500';
            if (fetching)
                return 'primary-500';
            return 'white';
        }
    }, [variant, disabled, fetching, loading]);
    return color;
};
